module.exports = __webpack_public_path__ + "img/add_btn_icon110.9ac1f03e.svg";